import { QueryObserverResult, useQuery } from 'react-query';
import useApiService from '../utilities/useApiService';

export const useFetchRequestItems = (
   pharmacyId: string,
   requestId: string
): [
   any | undefined,
   () => void,
   Omit<QueryObserverResult<any>, 'data' | 'refetch'>
] => {
   const { getMethod } = useApiService();

   const { data, refetch, ...state } = useQuery({
      queryKey: [`/pharmacies/${pharmacyId}/returnrequests/${requestId}/items`],
      queryFn: (context) => {
         if (!pharmacyId || !requestId) return undefined;
         return getMethod(
            `/pharmacies/${pharmacyId}/returnrequests/${requestId}/items`,
            { signal: context.signal }
         );
      },
      select: (response) => response?.data,
   });

   return [data, () => refetch({ cancelRefetch: true }), state];
};
